import React, { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { EditableElement } from 'mailup-web-components'

import { panelEditRecipientChangeFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/recipient'
import { dynamicFieldSelector } from 'Pages/RecipientsList/recoil/state/columns'

interface InputFieldProps {
  fieldId: number
  value: string
}

const InputField: FC<InputFieldProps> = ({ value, fieldId }) => {
  const intl = useIntl()

  const field = useRecoilValue(dynamicFieldSelector(fieldId))

  const editField = useRecoilCallback(panelEditRecipientChangeFieldCallback, [])

  const handleChange = (v: string): void => {
    void editField(fieldId, v)
  }

  const masked = field !== undefined ? field.masked : true

  return (
    <EditableElement
      value={masked ? '*****' : value}
      onChange={handleChange}
      placeholder={intl.formatMessage({
        id: 'Load.RecipientsList.InputFieldPlaceholder',
      })}
      multiline
      maxLength={200}
      disabled={masked}
    />
  )
}

export default InputField
